<app-topnav></app-topnav>
<div class="mb-10"></div>
<div class="container">
    <div class="content">

        <div class="word-content">
            <span class="page-title">TERMS OF USE - CMHA BOUNCEBACK® PROGRAM</span>
            <p>EFFECTIVE DECEMBER 2021</p>
            <p>Please review these Terms of Use carefully. IMPORTANT! These Terms of Service (“Terms” or
                “Agreement”) govern the use and access of this website (the “Site”)
                and our services (collectively, the “Services”) which are owned, operated and provided by CMHA
                BounceBack (“BounceBack”, “we”, “our”, “us”).
            </p>
            <p>
                As a user of the Site or Services “you”, “your”, “user” or “individual(s)”, we are referring to the
                person accessing the Site or Services.
                Any person who wishes to use our Site and Services must accept these Terms without change.
            </p>
            <p>
                BY USING THE SITE OR SERVICES OR BY CLICKING TO ACCEPT THE TERMS, YOU ACCEPT AND AGREE TO BE BOUND
                AND COMPLY WITH THESE TERMS, AND OUR PRIVACY POLICY,
                FOUND AT <a
                    href='https://bouncebackvideo.ca/about/privacy_policy'>https://bouncebackvideo.ca/about/privacy_policy</a>,
                INCORPORATED HEREIN BY REFERENCE. IF YOU DO NOT AGREE TO THESE TERMS AND/OR THE PRIVACY POLICY, YOU
                MUST NOT ACCESS OR USE THE SITE OR THE SERVICES.
            </p>
            <p>
                BY USING THIS SITE, YOU REPRESENT AND WARRANT THAT YOU ARE THE LEGAL AGE OF MAJORITY UNDER
                APPLICABLE LAW TO FORM A BINDING CONTRACT WITH BOUNCEBACK
                AND MEET ALL OF THE FOREGOING ELIGIBILITY REQUIREMENTS.
                IF YOU DO NOT MEET ALL OF THESE REQUIREMENTS, YOU MUST NOT ACCESS OR USE THE SITE OR THE SERVICES.
            </p>
            <p>
                THE CONTENT FOUND ON THE SITE AND THE SERVICES OFFERED SHOULD NOT BE VIEWED AS FULSOME TREATMENT FOR
                A MEDICAL OR PSYCHOLOGICAL AILMENT,
                AND IT SHOULD NEVER BE SOLELY RELIED UPON AS A SUBSTITUTE FOR SEEKING ADVICE OR TREATMENT FROM A
                HEALTHCARE PROFESSIONAL.
            </p>
            <ol>
                <li>
                    <span class="title">Acceptance of the Terms</span>
                    <p>
                        These Terms constitute the entire and only agreement between us, and supersedes any prior
                        agreements, representations,
                        warranties and understandings with respect to the Site and the Services.
                        <br><br>
                        By agreeing, BounceBack grants you a limited, revocable, personal, non-sub-licensable,
                        non-transferable, non-exclusive right to access
                        and use the Site and the Services in accordance with these Terms.
                        You cannot use the Site or the Services for resale or to provide services to third parties.
                    </p>
                </li>

                <li>
                    <span class="title">Modifications to Terms</span>
                    <p>
                        This paragraph is not applicable to consumers in the Province of Québec, please see
                        paragraph
                        immediately below.
                        We may change these Terms or any other policies or guidelines governing our Site, and
                        Services
                        at any time in our sole discretion.
                        Any changes will be effective upon the posting of the revisions on our Site. Your use of our
                        Site and Services will be subject to the most
                        current version of the Terms posted on our Site at the time of such use. Your continued use
                        of
                        our Site and Services after such changes are
                        implemented constitutes your acknowledgment and acceptance of the changes. Please consult
                        these
                        Terms regularly. If you do not agree to any
                        changes to these Terms, please immediately discontinue your use of our Site and Services.
                        <br><br>
                        For consumers in the Province of Québec: We may, from time to time amend any or each of the
                        provisions of these Terms or any other
                        policies or guidelines governing our Site and Services in relation to elements provided in
                        the
                        following sections and items: 3 (Use of the Site),
                        4 (User Name/Password), 6 (License Grant and Restrictions on Use), 7 (System Integrity), 8
                        (Protection of Privacy and Security), 14 (Term and termination),
                        21 (Contacting BounceBack). Such notice, written clearly and legibly, shall exclusively
                        contain
                        the amended terms and their earlier version,
                        the effective date and the notice informing you of your right to refuse the amendment and
                        cancel
                        your subscription, and the related Terms.
                        If the change results in an increase of your obligations or in a reduction of our
                        obligations,
                        you can refuse such change and terminate your use,
                        as amended, without penalty or termination fee by sending us a notice of termination within
                        thirty (30) days of the entry into force of the amendment.
                        Upon expiry of this period, you will be deemed to have accepted the changes and any
                        subsequent
                        termination will be in accordance with the terms of
                        the Terms as amended.
                        <br><br>
                        In the Province of Québec, a “consumer” means a natural person, except a merchant who
                        obtains
                        goods or services for the purposes of his business.
                    </p>
                </li>

                <li>
                    <span class="title">Use of the Site</span>
                    <p>
                        We expect that you will access and use our Site and Services in a professional, responsible
                        and
                        business-like manner in accordance with applicable laws.
                        <br><br>
                        You further agree that you must use our Site and Services for lawful purposes only and
                        represent
                        and warrant that you will not use our Site and Services to:

                    </p>
                    <ol type="a">
                        <li>
                            <p>
                                e-mail, provide us with or otherwise transmit any information that you do not have a
                                right to transmit under any law or under contractual
                                or fiduciary relationships (such as proprietary and confidential information learned
                                or
                                disclosed as part of employment relationships
                                or under nondisclosure agreements).
                            </p>
                        </li>
                        <li>
                            <p>
                                e-mail, provide us with or otherwise transmit any information or content that
                                infringes,
                                misappropriates, or otherwise violates any third party's
                                copyright, patent, trade-mark, or other proprietary right, including the right of
                                publicity or privacy, or encourages or enables any other party to do so.
                            </p>
                        </li>
                        <li>
                            <p>
                                remove any proprietary notices or labels, or any promotional or advertising
                                material,
                                from our Site and Services.
                            </p>
                        </li>
                        <li>
                            <p>
                                e-mail, transmit or send via the Internet any unsolicited or unauthorized
                                advertising,
                                branding, promotional materials,
                                commercial solicitation, political campaigning, “junk mail,” “spam,” “chain
                                letters,”
                                “pyramid schemes,” contests,
                                sweepstakes and other sales promotions, barter, or advertising or any other form of
                                solicitation.
                            </p>
                        </li>
                        <li>
                            <p>
                                impersonate any person or entity or misrepresent your affiliation with any other
                                person,
                                company or entity, including without limitation, using a false email address or
                                misleading us as to your
                                identity when you are on our Site or otherwise communicating with us.
                            </p>
                        </li>
                        <li>
                            <p>
                                upload, e-mail, send via the Internet or otherwise transmit, any software viruses or
                                any
                                other computer code,
                                files or programs designed to interrupt, destroy, alter, or limit the functionality
                                of
                                any computer software
                                or hardware or telecommunications equipment or that imposes an unreasonable or
                                disproportionately large load on the Site's
                                infrastructure or limits the functionality of any BounceBack or third party computer
                                hardware, software, networks,
                                or hardware or telecommunications equipment.
                            </p>
                        </li>
                        <li>
                            <p>
                                interfere or attempt to interfere with or disrupt our Site or Services including but
                                not
                                limited to our servers or networks
                                connected to our Site, including attempting to interfere with the access of any
                                other
                                user, host or network,
                                including without limitation, overloading, initiating, propagating, participating,
                                directing or attempting any “denial of service” attacks,
                                “spamming”, “crashing”, “flooding” or “mail-bombing” our Site or disobeying any
                                requirements, procedures, policies or
                                regulations of networks connected to our Site and Services.
                            </p>
                        </li>
                        <li>
                            <p>
                                direct bots, spiders, crawlers, avatars, intelligent agents or any other automated
                                process at our
                                computer systems or otherwise, create unreasonable load upon any of our computer
                                hardware, network, storage, input/output or electronic control devices.
                            </p>
                        </li>
                        <li>
                            <p>
                                intentionally or unintentionally violate any applicable local, provincial, national
                                or
                                international law,
                                rule or regulation applicable in connection with our Site and Services.
                            </p>
                        </li>
                        <li>
                            <p>
                                modify, adapt, assign, copy, sublicense, translate, rent, sell, reverse engineer,
                                decompile or
                                disassemble any of our Services, including but not limited to any portion of our
                                Site.
                            </p>
                        </li>
                        <li>
                            <p>
                                collect, use, disclose, store or distribute any personal information of a third
                                party
                                without their consent.
                            </p>
                        </li>
                        <li>
                            <p>
                                transmit any information or Registration Information known by you to be false,
                                inaccurate or misleading.
                            </p>
                        </li>
                        <li>
                            <p>
                                transmit any information or Registration Information that is intimate, private or
                                that
                                you would not want the public to view or have access to.
                            </p>
                        </li>
                        <li>
                            <p>
                                Otherwise send false or misleading information via the Site.
                            </p>
                        </li>
                        <li>
                            <p>
                                Use the Site to advertise to any user.
                            </p>
                        </li>
                        <li>
                            <p>
                                Otherwise make commercial use of the Site.
                            </p>
                        </li>
                    </ol>
                    <p>
                        Without limiting the foregoing, you warrant and agree that your use of the Site shall not:
                    </p>
                    <ol type="a">
                        <li>
                            <p>
                                In any manner violate the terms of use of any third-party website that is linked to the
                                Site, including but not limited to, any third-party social media website.
                            </p>
                        </li>
                        <li>
                            <p>
                                Include or contain any material that is exploitive, obscene, harmful, threatening,
                                abusive, harassing, hateful,
                                defamatory, sexually explicit or pornographic, violent, inflammatory, or discriminatory
                                based on race, sex,
                                religion, nationality, disability, sexual orientation, or age or other such legally
                                prohibited ground or
                                be otherwise objectionable, such determination to be made in BounceBack's sole
                                discretion.
                            </p>
                        </li>
                        <li>
                            <p>
                                Involve stalking, attempting to exploit or harm any individual (including minors) in any
                                way by exposing them to
                                inappropriate content or otherwise or ask for personal information as prohibited under
                                applicable laws, regulations, or code.
                            </p>
                        </li>
                        <li>
                            <p>
                                Impersonate or attempt to impersonate BounceBack, a BounceBack employee, another user,
                                or any other person or entity
                                (including, without limitation, by using email addresses, or screen names associated
                                with any of the foregoing).
                            </p>
                        </li>
                        <li>
                            <p>
                                Encourage any other conduct that restricts or inhibits anyone's use of the Site, or
                                which, may harm the BounceBack or users of the Site or expose them to liability.
                            </p>
                        </li>
                        <li>
                            <p>
                                Cause annoyance, inconvenience, or needless anxiety or be likely to upset, embarrass, or
                                alarm any other person.
                            </p>
                        </li>
                        <li>
                            <p>
                                Promote any illegal activity, or advocate, promote, or assist any unlawful act.
                            </p>
                        </li>
                        <li>
                            <p>
                                Give the impression that they originate from or are endorsed by us or any other person
                                or entity, if this is not the case.
                            </p>
                        </li>
                    </ol>
                    <p>
                        If we believe that there is a violation of these Terms that can be simply remedied by you,
                        we may ask you to take direct action rather than intervene. However, in other cases,
                        we may be required to formally investigate a violation of these Terms and determine the
                        appropriate action to address the matter.
                        <br><br>
                        If you are unable to act in accordance with our requested actions and we believe you are a
                        credible risk of harm to BounceBack,
                        other users, or third parties, we may terminate permission or license granted by these Terms,
                        ban you from the Site and/or stop
                        providing any Services.
                        <br><br>
                        You will be required to register and/or set up an account to use certain portions of our
                        Services.
                        In order to do so, you may be provided, or required to choose, a password, username, and/or
                        other
                        registration information, including, but not limited to, your personal information
                        (“Registration Information”).
                        You agree and represent that all Registration Information provided by you is accurate and
                        up-to-date.
                        If any of your Registration Information changes, you must update it by using the appropriate
                        update
                        mechanism on our Site, if available. If we believe that the Registration Information that you
                        provided
                        is not correct, current, or complete, we reserve the right to refuse you access to our Site or
                        the Services.
                        However, we have no obligation to verify the accuracy, currency completeness or usefulness of
                        any Registration
                        Information that you have provided to us.
                    </p>
                </li>

                <li>
                    <span class="title"> Username/Password</span>
                    <p>
                        If you register or set up an account on the Site, you will be solely responsible for maintaining
                        the confidentiality of
                        any username, password, and similar information. You may not authorize others to use your
                        username, password, or similar
                        information. You are solely responsible for all usage or activity on your account including, but
                        not limited to,
                        use of the account by any person who uses your Registration Information, with or without
                        authorization,
                        or who has access to any computer on which your account resides or is accessible.
                        <br><br>
                        If you have reason to believe that your account is no longer secure (for example, following a
                        loss, theft or unauthorized
                        disclosure or use of your Registration Information), you must promptly change the affected
                        Registration Information by
                        using the appropriate update mechanism on the Site, if available. We will not be responsible for
                        the unauthorized use
                        of your profile by any other person and disclaim any and all liability that may be associated
                        with such use.
                        <br><br>
                        This paragraph is not applicable to consumers in the Province of Québec. Please see the
                        paragraph that immediately follows.
                        We have the right to cancel or suspend or terminate your account, your use or your access to the
                        Site, Services, as well
                        as remove and delete any information or Registration Information related to the Site or any one
                        of the Services
                        (and terminate your use thereof), for any reason whatsoever and at any time in our sole
                        discretion, without notice
                        and without liability to you or any other person.
                        <br><br>
                        For consumers in the Province of Québec: If you are not in default in the performance of your
                        obligations under these Terms,
                        and we decide to cancel or terminate your account, your use or your access to the Site or the
                        Services, as well as remove
                        and delete any information or Registration Information related to the Site or any one of the
                        Services (and terminate your
                        use thereof), we will notify you in writing at least 60 days before the effective date of
                        termination or cancellation.
                        To the extent permissible by applicable law, we have the right to cancel or suspend or terminate
                        your account, your use
                        or your access to the Site or the Services at any time if you are in default in the performance
                        of your obligations
                        under these Terms.
                    </p>
                </li>
                <li>
                    <span class="title"> Links</span>
                    <p>
                        Our Site may contain hyperlinks to other sites that are not maintained by, or related to,
                        BounceBack. Hyperlinks to such sites are provided
                        solely as a convenience to you and do not imply any endorsement by BounceBack of, any
                        affiliation with or endorsement by the owner of the
                        linked site. We have no control over such third party sites. We are not responsible for the
                        availability of such external sites and no
                        endorsement of any third party products or services is expressed or implied by any information,
                        material or content referred to or included
                        on or linked from or to our Services or Site. Use of such third party sites, including any
                        information, material and services in these sites,
                        is solely at your own risk. You also understand and agree that our Privacy Policy is applicable
                        only while you are using our Services and Site.
                        Once you are linked to another site, you should read the privacy statement of that site before
                        disclosing any personal information.
                    </p>
                </li>
                <li>
                    <span class="title"> License Grant and Restrictions on Use</span>
                    <p>
                        So long as you comply with these Terms, BounceBack hereby grants to you a limited,
                        non-exclusive, non-transferable,
                        revocable, non-sublicensable right to use the Site solely for the purposes of accessing and
                        using the Services.
                        You may not use our Site or Services for any other purpose without our express prior written
                        consent.
                        <br><br>
                        You may not and may not authorize any other party to co-brand our Services without the express
                        prior written permission
                        of an authorized representative of BounceBack. For purposes of these Terms, “co-branding” means
                        to display any name,
                        logo, trade-mark, or other means of attribution or identification of any party in such a manner
                        as is reasonably likely
                        to give a user the impression that such other party has the right to display, publish, or
                        distribute our Services or
                        which may confuse a user as the nature of the relationship between us and any party.
                        <br><br>
                        You may link to our Site, provided you do so in a way that is fair and legal and does not damage
                        or take
                        advantage of our reputation, but you must not establish a link in such a way as to suggest any
                        form of association,
                        approval or endorsement on our part where none exists.
                        <br><br>You must not establish a link from any website that is not owned by you. The Sites must
                        not be framed on any other site,
                        nor may you create a link to any part of the Sites other than the homepage. We reserve the right
                        to withdraw linking permission
                        without notice, for any or no reason. The website from which you are linking must comply in all
                        respects with these Terms of use.
                        <br><br>
                        You agree to cease and desist causing any unauthorized co-branding and framing or hyperlinking
                        upon notice from us and
                        at all times you will cooperate with us following our discovery of any such illegal activity.
                        <br><br>
                        To the extent permissible under applicable law, BounceBack may, at any time and without notice
                        to you, suspend, limit or
                        terminate access or use of all or part of the Site or the Services for any reason and without
                        any liability to you
                        whatsoever. While BounceBack takes great care to ensure the Site and Services are accurate,
                        errors and/or inaccuracies
                        may occur. BounceBack may change or update information on the Site at any time without notice,
                        and availability of the
                        Services. We make no representations that the Site and/or the Services are compatible with, or
                        will function or operate
                        with your device or equipment.
                    </p>
                </li>
                <li>
                    <span class="title">System Integrity</span>
                    <p>
                        You are prohibited from using any services or facilities provided in connection with our Site or
                        Services to compromise
                        security or tamper with our system resources and/or accounts. The use or distribution of tools
                        designed for compromising
                        security (e.g., password guessing programs, cracking tools or network probing tools) is strictly
                        prohibited. You may not
                        use any device, software or routine to interfere or attempt to interfere with the proper working
                        of the Site. You may
                        not take any action which imposes an unreasonable or disproportionately large load on
                        BounceBack's infrastructure. When
                        using the Site, the communication of data may be transmitted over networks in which BounceBack
                        cannot guarantee secure
                        or reliable data transmission. We reserve the right to investigate suspected violations of these
                        Terms and to fully
                        cooperate with any law enforcement authorities or court order requesting or directing us to
                        disclose the identity of
                        anyone believed to be violating these Terms.
                        <br><br>
                        The security of your personal information is very important to us. We use physical, electronic,
                        and administrative
                        measures designed to secure your personal information from accidental loss and from unauthorized
                        access, use,
                        alteration, and disclosure.
                        <br><br>
                        The safety and security of your information also depends on you. Users are responsible for
                        obtaining their own access to
                        the Site. Users are required to ensure that all persons who access the Site through a user's
                        internet connection are
                        aware of these Terms and comply with them. It is a condition of your use of the Site that all
                        the information you
                        provide on the Site is correct, current, and complete.
                        <br><br>
                        Unfortunately, the transmission of information via the Internet is not completely secure.
                        Although we do our best to
                        protect your personal information, we cannot guarantee the security of your personal information
                        transmitted to our
                        Site. Any transmission of personal information is at your own risk. We are not responsible for
                        circumvention of any
                        privacy settings or security measures contained on the Site.
                    </p>
                </li>
                <li>
                    <span class="title"> Protection of Privacy and Security</span>
                    <p>
                        To review how we collect, use or disclose your Personal Information, you may refer to our
                        Privacy Policy
                        <br><br>
                        In order to maintain the privacy and security of the Site, you must not disclose any security or
                        privacy vulnerabilities
                        to any person except BounceBack. Immediately upon discovering any issues that may be pose a
                        threat to the privacy and
                        security of the Sites or data stored within the Site, you must notify us at <a
                            href="mailto:bounceback@cmha.bc.ca">
                            bounceback&#x40;cmha.bc.ca</a>
                    </p>
                </li>
                <li>
                    <span class="title">No Reliance</span>
                    <p>
                        Some jurisdictions (including the Province of Québec) do not allow certain exclusions or
                        limitations on implied
                        warranties, so the following exclusions and limitations may not apply to you.
                        <br><br>
                        The content on our Site is provided for general information purposes only. It is not intended to
                        amount to advice on
                        which you should rely. You must obtain more specific or professional advice before taking, or
                        refraining from, any
                        action or inaction on the basis of the content on our Site.
                        <br><br>
                        Although we make reasonable efforts to update the information on our Site, we make no
                        representations, warranties, or
                        guarantees, whether express or implied, that the content on our Site is accurate, complete, or
                        up to date. Your use of
                        the Site is at your own risk and neither BounceBack nor its parent, subsidiaries, affiliates,
                        and their respective
                        directors, officers, employees, agents, service providers, contractors, licensors, licensees,
                        suppliers, or successors
                        has no/have any responsibility or liability whatsoever for your use of this Site.
                        <br><br>
                        This Site may include content provided by third parties, including from other users and
                        third-party licensors. All
                        statements and/or opinions expressed in any such third-party content, other than the content
                        provided by BounceBack, are
                        solely the opinions and the responsibility of the person or entity providing those materials.
                        Such materials do not
                        necessarily reflect the opinion of BounceBack. Neither BounceBack nor its parent, subsidiaries,
                        affiliates, and their
                        respective directors, officers, employees, agents, service providers, contractors, licensors,
                        licensees, suppliers, or
                        successors has no/have any responsibility or liability whatsoever to you, or any third party,
                        for the content or
                        accuracy of any third-party materials.
                        <br><br>
                        BounceBack has made every effort to ensure the proper function of the Site, however BounceBack
                        is not responsible for
                        any damages incurred while using the Site or Services. We do not warrant that the Site or
                        Services will be error-free or
                        that any defects will be corrected. We may make changes to the Site's features, functionality,
                        or other components at
                        any time.
                    </p>
                </li>

                <li>
                    <span class="title"> Intellectual Property and Ownership</span>
                    <p>
                        You understand and agree that the Services, as well as the Site and its entire contents,
                        features, and functionality,
                        including, but not limited to, all information, software, code, data text, displays, graphics,
                        photographs, images,
                        video, audio, music, broadcast, design, presentation, website layout, selection, and
                        arrangement, are owned by
                        BounceBack, its licensors, or other providers of such material and are protected by intellectual
                        property laws including
                        without limitation, copyright, trademark, patent, trade secret, and any other proprietary
                        rights.
                        <br><br>
                        BounceBack's name, trademarks, logos and all related names, logos, product and Service names,
                        designs, images, and
                        slogans are trademarks of BounceBack or its affiliates or licensors. You must not use such marks
                        without the prior
                        written permission of BounceBack. Other names, logos, product and Service names, designs,
                        images, and slogans mentioned,
                        or which appear on this Site are the trademarks of their respective owners. Use of any such
                        property, except as
                        expressly authorized, shall constitute an infringement or violation of the rights of the
                        property owner and may be a
                        violation of federal or other laws and could subject the infringer to legal action.
                        <br><br>
                        Users are not permitted to modify copies of any materials from this Site nor delete or alter any
                        copyright, trademark,
                        or other proprietary rights notices from copies of materials from the Site. You must not access
                        or use for any
                        commercial purposes any part of the Site or any Services or materials available through the
                        Site.
                        <br><br>
                        Images, audio files and videos on our Site must not be altered or digitally enhanced, and their
                        use must be in
                        accordance with Canada's Copyright Act (R.S.C., 1985, c.C-42). Any other use or alteration of
                        the material is strictly
                        prohibited without our prior written permission. BounceBack will have a royalty-free, worldwide,
                        transferable,
                        sublicensable, irrevocable, perpetual license to use or incorporate into the Site any
                        suggestions, enhancement requests,
                        recommendations or other feedback provided by you, relating to the Site.
                        <br><br>
                        You may only use the Site and the Services for your personal and non-commercial use. You shall
                        not directly or
                        indirectly reproduce, compile for an internal database, distribute, modify, create derivative
                        works of, publicly
                        display, publicly perform, republish, download, store, or transmit any of the material on our
                        Site in any form or medium
                        whatsoever except:
                    </p>
                    <ol type="a">
                        <li>
                            <p>
                                Your computer and browser may temporarily store or cache copies of materials being
                                accessed and viewed;
                            </p>
                        </li>
                        <li>
                            <p>
                                a reasonable number of copies for personal use only may be printed keeping any
                                proprietary notices thereon, which may
                                only be used for non-commercial and lawful personal use and not for further
                                reproduction, publication, or distribution
                                of any kind on any medium whatsoever; and
                            </p>
                        </li>
                        <li>
                            <p>
                                content may be downloaded with any proprietary notices intact, and solely for your own
                                personal, non‑commercial use.
                            </p>
                        </li>
                    </ol>
                    <p>
                        If you print off, copy, or download any part of our Site in breach of these Terms, your right to
                        use the Site will cease
                        immediately and you must, at our option, return or destroy any copies of the materials you have
                        made. You have no right,
                        title, or interest in or to the Site or to any content on the Site, and all rights not expressly
                        granted are reserved by
                        BounceBack. Any use of the Site not expressly permitted by these Terms is a breach of these
                        Terms and may infringe or
                        violate copyright, trademark, and other intellectual property or other proprietary laws.
                    </p>
                </li>
                <li>
                    <span class="title">Limitation of liability and disclaimer of warranty</span>
                    <p>
                        SOME JURISDICTIONS (INCLUDING THE PROVINCE OF QUÉBEC) DO NOT ALLOW CERTAIN EXCLUSIONS OR
                        LIMITATIONS ON IMPLIED
                        WARRANTIES OR LIABILITY, SO THE BELOW EXCLUSIONS AND LIMITATIONS WILL ONLY APPLY TO THE EXTENT
                        PERMISSIBLE BY APPLICABLE
                        LAW.
                        <br><br>
                        BounceBack represents, warrants and covenants to you that: (a) it has the full power and
                        authority to offer the program
                        in Canada (as contemplated hereunder on the terms and conditions in these Terms); and (b) the
                        Services will be provided
                        in a professional and workmanlike manner in accordance with these Terms.
                        <br><br>
                        You understand that we will use commercially reasonable efforts to provide our Site or Services
                        but we cannot and do not
                        guarantee or promise any specific and intended results from the use of our Site or Services. You
                        acknowledge that any
                        reliance on our Site or Services will be at your own risk and that you must evaluate and bear
                        all risks associated with
                        the use of our Site and Services. YOU ARE SOLELY RESPONSIBLE FOR ANY USE OF OUR SITE OR
                        SERVICES. YOUR USE OF OUR SITE
                        AND SERVICES IS ENTIRELY AT YOUR OWN RISK. BOUNCEBACK WILL NOT BE RESPONSIBLE FOR ANY OF YOUR
                        ACTS OR OMISSIONS OR THOSE
                        OF ANY OTHER PARTY.
                        <br><br>
                        From time to time, the Sites may be unavailable for reasons within BounceBack's control such as
                        system maintenance or
                        reasons outside of BounceBack's control. When this occurs, BounceBack is not liable to you or
                        other users for any
                        interruptions in the use of our Sites or Services.
                        <br><br>
                        WE DO NOT REPRESENT OR WARRANT THAT FILES OR INFORMATION AVAILABLE FOR ACCESS OR DOWNLOADING
                        FROM THE INTERNET,
                        HYPERLINKED SITES, OUR SITE OR ANY FILES AND EMAILS FROM US WILL BE FREE OF VIRUSES, WORMS,
                        MALWARE, TROJAN HORSES OR
                        OTHER CODE THAT MAY MANIFEST CONTAMINATING OR DESTRUCTIVE PROPERTIES. YOUR USE OF THE INTERNET
                        IS AT YOUR OWN RISK AND
                        YOU ARE SOLELY RESPONSIBLE FOR ANY DAMAGES TO YOUR COMPUTER SYSTEMS OR LOSS OF DATA THAT RESULTS
                        FROM ANY INTERNET
                        ACCESS OR OUR SITE OR SERVICES.
                        <br><br>
                        YOUR USE OF OUR SITE AND SERVICES IS AT YOUR OWN RISK. OTHER THAN OUR EXPLICIT REPRESENTATIONS
                        AND WARRANTIES OUTLINED
                        HEREIN, OUR SITE AND SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT
                        REPRESENTATIONS, WARRANTIES,
                        GUARANTEES OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE EXPRESSLY DISCLAIM ALL
                        REPRESENTATIONS, WARRANTIES,
                        GUARANTEES AND CONDITIONS, INCLUDING ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                        PARTICULAR PURPOSE, TITLE,
                        QUIET ENJOYMENT OR NON-INFRINGEMENT OR THOSE ARISING OUT OF A COURSE OF DEALING, PERFORMANCE OR
                        USAGE OF TRADE. WE MAKE
                        NO REPRESENTATIONS, WARRANTIES OR CONDITIONS REGARDING THE AVAILABILITY APPROPRIATENESS,
                        COMPLETENESS, ACCURACY, OR
                        CURRENCY OF OUR SITE OR SERVICES. FOR GREATER CLARITY, WE DO NOT REPRESENT OR WARRANT THAT:
                    </p>
                    <ol type="a">
                        <li>
                            <p>
                                OUR SITE OR SERVICES DO NOT AND WILL NOT INFRINGE, OR BE SUBJECT TO ANY INTELLECTUAL
                                PROPERTY CLAIMS, OR A CLAIM OF
                                INFRINGING THE TRADEMARK OR OTHER RIGHTS OF ANOTHER PARTY;
                            </p>
                        </li>
                        <li>
                            <p>
                                OUR SITE WILL BE UNINTERRUPTED, FUNCTIONAL, SECURE, RELIABLE, ACCURATE, COMPLETE,
                                CURRENT, USEFUL, SUITABLE, WILL MEET
                                YOUR REQUIREMENTS OR ERROR-FREE;
                            </p>
                        </li>
                        <li>
                            <p>
                                ANY DEFECTS IN OUR SITE OR SERVICES WILL BE CORRECTED; AND,
                            </p>
                        </li>
                        <li>
                            <p>
                                WE HAVE VERIFIED OR ENDORSED ANY THIRD PARTY CONTENT.
                            </p>
                        </li>
                    </ol>
                    <p>
                        IN NO EVENT SHALL BOUNCEBACK, ITS DIRECTORS, OFFICERS, SHAREHOLDERS, EMPLOYEES, LICENSORS, THIRD
                        PARTY PROVIDERS,
                        AGENTS, CONTRACTORS, ADVISORS AND THE RESPECTIVE SUCCESSORS AND ASSIGNS (“ASSOCIATED PERSONS”)
                        BE LIABLE TO YOU OR ANY
                        OTHER PERSON OR ENTITY FOR ANY DIRECT, INDIRECT, EXEMPLARY, SPECIAL, INCIDENTAL, CONSEQUENTIAL
                        OR PUNITIVE DAMAGES,
                        INCLUDING LOSS OF INCOME, LOSS OF PROFITS, LOSS OF ANTICIPATED SALES, LOSS OF OPPORTUNITIES,
                        BUSINESS INTERRUPTION,
                        FAILURE TO REALIZE UNEXPECTED SAVINGS, DAMAGE TO PROPERTY, PHYSICAL HARM, PSYCHOLOGICAL HARM,
                        CLAIMS OF THIRD PARTIES,
                        LOSS OF GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES OR OTHER ECONOMIC OR PERSONAL LOSS
                        ARISING FROM OR IN CONNECTION
                        WITH THE USE OF THE SITE OR THE SERVICES INCLUDING, WITHOUT LIMITATION:
                    </p>
                    <ol type="a">
                        <li>
                            <p>
                                YOUR USE OF OR RELIANCE ON ANY INFORMATION PROVIDED BY US ON OUR SITE OR SERVICES;
                            </p>
                        </li>
                        <li>
                            <p>
                                YOUR USE OF OR INABILITY TO USE OUR SITE OR SERVICES;
                            </p>
                        </li>
                        <li>
                            <p>
                                YOUR VIOLATIONS OF TRADEMARK INFRINGEMENT OR OTHER INTELLECTUAL PROPERTY RIGHTS;
                            </p>
                        </li>
                        <li>
                            <p>
                                ANY FAILURE OF PERFORMANCE OF OUR SITE AND SERVICES, WHETHER RELATED TO ERROR, OMISSION,
                                INTERRUPTION, DEFECT, DELAY IN
                                OPERATION OR TRANSMISSION, COMPUTER VIRUSES OR NETWORK FAILURE;
                            </p>
                        </li>
                        <li>
                            <p>
                                THE UNAUTHORIZED USE OF YOUR ACCOUNT AND PASSWORD BY ANY PERSON;
                            </p>
                        </li>
                        <li>
                            <p>
                                ANY THIRD PARTY CONTENT OR HYPERLINKED SITES;
                            </p>
                        </li>
                        <li>
                            <p>
                                YOUR REGISTRATION INFORMATION OR INFORMATION THAT YOU TRANSMITTED OR SHARED THROUGH OR
                                IN CONNECTION WITH OUR SERVICES; OR
                            </p>
                        </li>
                        <li>
                            <p>
                                ANY OTHER MATTERS RELATING TO OUR SITE AND SERVICES, WHETHER BASED IN CONTRACT,
                                NEGLIGENCE, STRICT LIABILITY,
                                FUNDAMENTAL BREACH, FAILURE OF ESSENTIAL PURPOSE OR OTHERWISE, WHETHER OR NOT WE HAD ANY
                                KNOWLEDGE, ACTUAL OR
                                CONSTRUCTIVE, THAT YOU MIGHT INCUR SUCH DAMAGES, AND WHETHER OR NOT THOSE DAMAGES MIGHT
                                HAVE BEEN FORESEEABLE. THE
                                LIMITATIONS ON BOUNCEBACK'S LIABILITY OR THE LIABILITY OF ASSOCIATED PERSONS TO YOU IN
                                THIS SECTION SHALL APPLY WHETHER
                                OR NOT BOUNCEBACK OR SUCH ASSOCIATED PERSONS HAVE BEEN ADVISED OR SHOULD HAVE BEEN AWARE
                                OF THE POSSIBILITY OF ANY SUCH
                                LOSSES ARISING.
                            </p>
                        </li>
                    </ol>
                    <p>
                        WE DISCLAIM ANY AND ALL SUCH ABOVE REPRESENTATIONS, WARRANTIES AND LIABILITIES TO THE FULLEST
                        EXTENT PERMISSIBLE UNDER
                        APPLICABLE LAW. CERTAIN JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS ON IMPLIED WARRANTIES OR
                        CONDITIONS OR THE
                        EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
                        DISCLAIMERS, EXCLUSIONS
                        OR LIMITATIONS MAY NOT APPLY TO YOU AND YOU MAY HAVE ADDITIONAL RIGHTS.
                    </p>
                </li>

                <li>
                    <span class="title">Indemnity</span>
                    <p>
                        You agree at all times to defend, indemnify and hold harmless BounceBack and its Associated
                        Persons (the “Indemnified
                        Parties”) from and against any claims, losses, judgements, actions, proceedings, damages, costs
                        and expenses (including
                        without limitation, reasonable legal and other fees and disbursements) incurred by any of the
                        foregoing parties due to
                        or resulting from your use or misuse of our Site or Services, or from your violation of these
                        Terms, including your
                        failure to appropriately obtain consent from a third party. You will also indemnify and hold the
                        Indemnified Parties
                        harmless from and against any claims brought by third parties arising out of your use of our
                        Site and Services,
                        including but not limited to trademark infringement or other intellectual property claims from
                        third parties.
                    </p>
                </li>

                <li>
                    <span class="title">Severability and waiver</span>
                    <p>
                        Unless as otherwise stated in the Agreement, should any provision of the Agreement be held
                        invalid or unenforceable for
                        any reason, it will not affect or make the remaining provisions in the Agreement unenforceable
                        or invalid to the extent
                        permitted by law.
                        <br><br>
                        This paragraph is not applicable to consumers in the Province of Québec. Except for liabilities
                        we have expressly not
                        excluded, our total aggregate liability relating to the Site shall be limited to $50 Canadian.
                        <br><br>
                        We will not be considered to have waived any of our rights or remedies described in these Terms
                        unless the waiver is in
                        writing and signed by us. No delay or omission by us in exercising our rights or remedies will
                        impair or be construed as
                        a waiver. Any single or partial exercise of a right or remedy will not preclude further exercise
                        of any other right or
                        remedy. Our failure to enforce the strict performance of any provision of these Terms will not
                        constitute a waiver of
                        our right to subsequently enforce such provision or any other provisions of these Terms. Other
                        than as expressly stated
                        herein, the remedies provided herein are in addition to, and not exclusive of, any other
                        remedies of a party at law or
                        in equity.
                    </p>
                </li>

                <li>
                    <span class="title">Term and termination</span>
                    <p>
                        This Agreement will commence on the date you access the Site or Services and continues until
                        terminated in accordance
                        with the provisions of these Terms. You acknowledge and agree that these Terms shall remain in
                        effect for so long as you
                        use our Site or Services. You agree that this Agreement can only be terminated by you once you
                        have stopped using our
                        Site or Services. We reserve the right to suspend or terminate your use of our Site or Services
                        and remove and discard
                        any information or Registration Information related to you and your use of our Site or Services
                        at any time, for any
                        reason, with or without cause, if we believe that you are violating these Terms in any way. If
                        you wish to terminate
                        your account, you may choose to cease use of the Site and the Services or to send us a
                        notification, which shall be
                        effective upon receipt. If you are dissatisfied with our Site or Services, including these
                        Terms, your sole remedy is to
                        discontinue using our Site, or Services by ceasing to use the Site, which includes ceasing to
                        use the Services.
                        <br><br>
                        Upon the termination of this Agreement for any reason, (a) the license granted to BounceBack in
                        respect of the personal
                        information you have provided to BounceBack will survive for so long as BounceBack is required
                        by law and clinical best
                        practice to retain such information; and (b) BounceBack will no longer provide and you will no
                        longer use the Site or
                        Services; and (c) BounceBack will retain and use your personal information in accordance with
                        the consent you provided
                        and our privacy policy or as, permitted or required by applicable laws..
                    </p>
                </li>

                <li>
                    <span class="title">Entire Agreement</span>
                    <p>
                        These Terms and any of our other legal notices, policies and guidelines linked to these Terms
                        constitute the entire
                        agreement between you and BounceBack relating to your use of our Site and Services and supersede
                        any prior or separate
                        understandings or agreements (whether oral or written), claims, representations, and
                        understandings of the parties
                        regarding such subject matter and the Terms may not be amended or modified except as mentioned
                        herein.
                    </p>
                </li>

                <li>
                    <span class="title"> No Agency; Third Party Beneficiary</span>
                    <p>
                        We are not your agent, fiduciary, trustee, or other representative. Nothing expressed or
                        mentioned in or implied from
                        these Terms is intended or will be construed to give to any person other than the parties hereto
                        any legal or equitable
                        right, remedy, or claim under or in respect to these Terms. These Terms and all of the
                        representations, warranties,
                        covenants, conditions, and provisions hereof are intended to be and are for the sole and
                        exclusive benefit of you and
                        BounceBack.
                    </p>
                </li>

                <li>
                    <span class="title">Assignment</span>
                    <p>
                        You may not assign, convey, subcontract or delegate your rights, duties or obligations hereunder
                        without our prior
                        written consent. BounceBack may assign these Terms and the rights and obligations granted
                        hereunder without your
                        consent.
                    </p>
                </li>

                <li>
                    <span class="title">Headings</span>
                    <p>
                        The headings used in these Terms are included for convenience only and have no legal or
                        contractual effect and shall not
                        affect the construction or interpretation of these Terms.
                    </p>
                </li>

                <li>
                    <span class="title">Language</span>
                    <p>
                        These Terms of use are available both in English and French. Subject to applicable law, any
                        non-English or French
                        translations of these Terms of Use provided by BounceBack will be upon request only and for your
                        convenience. It is the
                        express wish of the parties to be only bound by the English version of these Terms and all
                        documents related or
                        ancillary. <i>Il est la volonté expresse des parties d'être liés seulement par la version
                            anglaise des présentes modalités
                            et de tous les documents s'y rattachant.</i>
                    </p>
                </li>

                <li>
                    <span class="title">Applicable Law</span>
                    <p>
                        This provision is not applicable to consumers in the Province of Québec, where any dispute will
                        be subject to the
                        jurisdictions of the courts of the Province of Québec.
                        <br><br>
                        The laws of British Columbia, Canada, without regard to principles of conflict of laws, govern
                        these Terms and any
                        dispute that might arise between you and BounceBack. The United Nations Convention on the
                        International Sale of Goods is
                        explicitly excluded from this Agreement. If you take legal action relating to these Terms, you
                        irrevocably agree to only
                        take such action within British Columbia and only to a court of competent jurisdiction within
                        British Columbia and in no
                        other jurisdiction or venue, and you now irrevocably consent and submit to the jurisdiction of
                        the courts of British
                        Columbia for this purpose.
                    </p>
                </li>

                <li>
                    <span class="title">Contacting BounceBack</span>
                    <p>
                        Please feel free to contact us if you have any questions or additional comments regarding this
                        Agreement. You may
                        contact us at:
                        <br><br>
                        <span class="contact-cmha">
                            <span>Canadian Mental Health Association, BC Division</span>
                            <span>905 - 1130 West Pender Street,</span>
                            <span>Vancouver BC, V6E 4A4</span>
                            <span>1-866-639-0522</span>
                            <span>bounceback&#x40;cmha.bc</span>
                        </span>
                    </p>
                </li>

                <li>
                    <span class="title">Last Modified</span>
                    <p>
                        These Terms were last modified on 22nd September 2022.
                    </p>
                </li>
            </ol>
        </div>

    </div>
</div>

<app-footer></app-footer>